import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Popup from "@arcgis/core/widgets/Popup";
import { v4 as uuidv4 } from "uuid";

export default class Store {
  private static instance: Store;

  MapView?: __esri.MapView;

  graphicsLayer?: __esri.GraphicsLayer;

  // private constructor() {
  // }
  createGraphicsLayer = (title: string, id?: string, opacity?: number) => {
    const graphicsLayer = new GraphicsLayer({
      id: id ? id : uuidv4(),
      opacity: opacity ? opacity : 100,
    });
    graphicsLayer.title = title;
    Store.instance.MapView?.map.add(graphicsLayer);
    Store.instance.graphicsLayer = graphicsLayer;
    if (Store.instance.MapView)
      Store.instance.MapView.popup = new Popup({
        dockEnabled: true,
        dockOptions: {
          position: "bottom-right",
        },
      });
    return graphicsLayer;
  };

  public static getInstance(): Store {
    if (!Store.instance) {
      Store.instance = new Store();
    }
    return Store.instance;
  }
}
